import { dispatchError, dispatchLoading, dispatchSuccess } from '../utils';
import { GET_BANNER, API_TIMEOUT } from '../utils/constant';

import axios from 'axios';

export const GET_LIST_BANNER = 'GET_LIST_BANNER';

export const getBanner = () => {
  return (dispatch) => {
    dispatchLoading(dispatch, GET_LIST_BANNER);

    axios({
      method: 'get',
      url: GET_BANNER,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          dispatchError(dispatch, GET_LIST_BANNER, 'error');
        } else {
          //BERHASIL

          dispatchSuccess(
            dispatch,
            GET_LIST_BANNER,
            response.data.data ? response.data.data : []
          );
        }
      })
      .catch((error) => {
        // ERROR
        dispatchError(dispatch, GET_LIST_BANNER, 'error');
        alert(error);
      });
  };
};
